// removed by extract-text-webpack-plugin
module.exports = {"yx_yxCircle_sm":"yx_yxCircle_sm","yx_yxShadow_right":"yx_yxShadow_right","yx_yxShadow_left":"yx_yxShadow_left","yx_yxShadow_down":"yx_yxShadow_down","yx_yxShadow_down_new":"yx_yxShadow_down_new","yx_yxRadius_sm":"yx_yxRadius_sm","yx_yxRadius_xs":"yx_yxRadius_xs","yx_yxLine":"yx_yxLine","ant-layout-content":"ant-layout-content"};


//////////////////
// WEBPACK FOOTER
// ./src/yx-widget/component/YxPanel/index.less
// module id = ./src/yx-widget/component/YxPanel/index.less
// module chunks = 43